import { getStatusColor, getStatusForeColor, getStatusLabel } from '@/utils';
import { PersonOutlined as PersonOutlinedIcon } from '@mui/icons-material';
import {
  Avatar,
  Box,
  ListItemButton,
  ListItemText,
  Tooltip,
} from '@mui/material';
import { cyan } from '@mui/material/colors';

export function ExternalPersonListItem({ item, feature, ...props }) {
  const primary = feature.properties.code;
  const secondary = feature.properties.role;

  return (
    <ListItemButton
      {...props}
      dense
      disableGutters
      sx={
        item
          ? {
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: `${item.size}px`,
              transform: `translateY(${item.start}px)`,
              px: 1,
            }
          : { px: 1 }
      }
    >
      <Box sx={{ pr: 1 }}>
        <Tooltip
          title={getStatusLabel(feature.properties.status)}
          placement="top"
        >
          <Avatar
            sx={{
              color: getStatusForeColor(feature.properties.status),
              bgcolor: getStatusColor(feature.properties.status),
              borderColor: getStatusForeColor(feature.properties.status),
              borderWidth: 2,
              borderStyle: 'solid',
            }}
          >
            <PersonOutlinedIcon />
          </Avatar>
        </Tooltip>
      </Box>
      <ListItemText
        primary={primary}
        secondary={secondary}
        slotProps={{
          primary: { noWrap: true },
          secondary: { noWrap: true },
        }}
      />
      {feature.properties.assignments?.callSign && (
        <Tooltip title="Call Sign" placement="right">
          <Box
            sx={{
              fontSize: 10,
              color: 'white',
              bgcolor: cyan[900],
              borderRadius: 1,
              px: 0.5,
              py: 0.25,
            }}
          >
            {feature.properties.assignments.callSign.code}
          </Box>
        </Tooltip>
      )}
    </ListItemButton>
  );
}
